import React, { useRef, useState } from "react";

export const LABEL_COLOR = { crack: "#EF4444", spalling: "#F59E0B", corrosion: "#FB923C", other: "#00FFFF" };
export const LABELS = Object.keys(LABEL_COLOR);
export const labelText = (l, tr) => (tr ? { crack: "çatlak", spalling: "dökülme", corrosion: "korozyon", other: "diğer" }[l] : l);

const pct = (v) => `${(v * 100).toFixed(2)}%`;
const norm = (e, el) => { const r = el.getBoundingClientRect(); return { x: Math.min(1, Math.max(0, (e.clientX - r.left) / r.width)), y: Math.min(1, Math.max(0, (e.clientY - r.top) / r.height)) }; };
const rect = (a, b) => ({ x: Math.min(a.x, b.x), y: Math.min(a.y, b.y), w: Math.abs(a.x - b.x), h: Math.abs(a.y - b.y) });

export const BoxOverlay = ({ boxes, testId, dim }) => (boxes || []).map((b, i) => (
  <div key={b.id || i} data-testid={`${testId}-box-${i}`} className="absolute pointer-events-none" style={{ left: pct(b.x), top: pct(b.y), width: pct(b.w), height: pct(b.h), border: `2px solid ${LABEL_COLOR[b.label] || "#00FFFF"}`, boxShadow: "0 0 0 1px rgba(0,0,0,.6)", opacity: dim ? 0.55 : 1 }}>
    <span className="absolute -top-4 left-0 text-[9px] font-mono px-1 whitespace-nowrap" style={{ background: LABEL_COLOR[b.label] || "#00FFFF", color: "#050A15" }}>{b.label}{b.area_pct != null ? ` ${b.area_pct}%` : ""}</span>
  </div>
));

export const AnnotatedImage = ({ src, alt, boxes, imgClass, drawing, onDraw, testId, onClick }) => {
  const ref = useRef(null); const [start, setStart] = useState(null); const [cur, setCur] = useState(null);
  const down = (e) => { if (!drawing) return; e.preventDefault(); ref.current.setPointerCapture?.(e.pointerId); const p = norm(e, ref.current); setStart(p); setCur(p); };
  const move = (e) => { if (!drawing || !start) return; setCur(norm(e, ref.current)); };
  const up = (e) => { if (!drawing || !start) return; const r = rect(start, norm(e, ref.current)); setStart(null); setCur(null); if (r.w >= 0.01 && r.h >= 0.01) onDraw?.(r); };
  const live = start && cur ? rect(start, cur) : null;
  return (
    <div ref={ref} className={`relative inline-block select-none ${drawing ? "cursor-crosshair touch-none" : ""}`} data-testid={testId} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerCancel={() => { setStart(null); setCur(null); }} onClick={onClick}>
      <img src={src} alt={alt} className={`block ${imgClass}`} draggable={false} data-testid={`${testId}-img`} />
      <BoxOverlay boxes={boxes} testId={testId} />
      {live && <div className="absolute border-2 border-dashed border-white/80 pointer-events-none" style={{ left: pct(live.x), top: pct(live.y), width: pct(live.w), height: pct(live.h) }} />}
    </div>
  );
};

export const groupStats = (photos) => {
  const out = {};
  photos.forEach((p) => (p.annotations || []).forEach((b) => { const s = out[b.label] || (out[b.label] = { area: 0, diag: 0, n: 0 }); s.area += b.area_pct || 0; s.diag = Math.max(s.diag, b.diag_pct || 0); s.n += 1; }));
  Object.values(out).forEach((s) => { s.area = Math.round(s.area * 100) / 100; });
  return out;
};

export const GrowthChips = ({ cur, prev, tr, testId }) => {
  const labels = Object.keys(cur);
  if (labels.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1" data-testid={testId}>
      {labels.map((l) => {
        const c = cur[l]; const p = prev?.[l]; const delta = p && p.area > 0 ? Math.round(((c.area - p.area) / p.area) * 100) : null;
        const txt = !prev ? "" : !p ? (tr ? " · yeni" : " · new") : delta === 0 ? (tr ? " · değişmedi" : " · unchanged") : ` · ${delta > 0 ? "↑" : "↓"} ${Math.abs(delta)} % ${tr ? "alan (öncekine göre)" : "area since previous"}`;
        return <span key={l} data-testid={`${testId}-${l}`} className="text-[9px] font-mono px-1.5 py-0.5 border" style={{ borderColor: `${LABEL_COLOR[l]}88`, color: LABEL_COLOR[l] }}>{labelText(l, tr)} {c.area} % · ⌀ {c.diag} %{txt}</span>;
      })}
    </div>
  );
};
